module.exports = __webpack_public_path__ + "static/bac-objetivos-icon-1-d28a5a3a002c1799aa26dd44b7a298b3.svg";